<template>
  <v-form :disabled="readonly">
    <v-app-bar
      color="#E57373"
      dark>
      <h3>
        <v-icon>mdi-feature-search-outline</v-icon>
        A. 整合性の確認表作成準備入力
      </h3>
    </v-app-bar>
    <stepper
      v-if="step!==0"
      v-model="currentStep"
      session-key-prefix="confirmation-step"
      :items="steps" />
    <confirmation-form-step1
      v-if="currentStep===2"
      :is-new="isNew"
      :features="features"
      :structures="structures"
      :previous-object="previousObject"
      :created="confirmationCreated"
      :applied="!!confirmationApplied"
      @hasChange="fetchIsChanged"
      @change="goStep" />
    <confirmation-form-step2
      v-if="currentStep===3"
      :is-new="isNew"
      :roles="roles"
      :license-types="licenseTypes"
      :previous-object="previousObject"
      :created="confirmationCreated"
      :applied="!!confirmationApplied"
      @hasChange="fetchIsChanged"
      @change="goStep" />
    <confirmation-form-step3
      v-if="currentStep===4"
      :is-new="isNew"
      :previous-object="previousObject"
      :created="confirmationCreated"
      :applied="!!confirmationApplied"
      @hasChange="fetchIsChanged"
      @change="goStep" />
    <confirmation-form-step4
      v-if="currentStep===5"
      :id="id"
      :is-new="isNew"
      :features="features"
      :structures="structures"
      :roles="roles"
      :license-types="licenseTypes"
      @hasChange="fetchIsChanged"
      @change="goStep" />
  </v-form>
</template>

<script>

import ConfirmationFormStep1 from './FormStep1'
import ConfirmationFormStep2 from './FormStep2'
import ConfirmationFormStep3 from './FormStep3'
import ConfirmationFormStep4 from './FormStep4'
import Stepper from '../Stepper'
import { getStepSession } from '../../logic/session'

import LeaveConfirm from '../../mixins/LeaveConfirm'

export default {
  name: 'ConfirmationForm',
  components: {
    Stepper,
    ConfirmationFormStep1,
    ConfirmationFormStep2,
    ConfirmationFormStep3,
    ConfirmationFormStep4,
  },
  mixins: [LeaveConfirm],
  props: {
    id: {
      type: [String, Number],
      default: null,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
    step: {
      type: Number,
      default: 2,
    },
    steps: {
      type: Array,
      default: () => ([
        { id: 1, title: '整合性確認表の選択' },
        { id: 2, title: '対象物件情報の入力' },
        { id: 3, title: '調査情報の入力' },
        { id: 4, title: '部屋情報の入力' },
        { id: 5, title: '保存確認' },
      ]),
    },
  },
  data() {
    return {
      structures: [],
      features: [],
      roles: [],
      licenseTypes: [],
      readonly: false,
      previousObject: {},
      confirmationCreated: false,
      confirmationApplied: false,
    }
  },
  computed: {
    currentStep() {
      return this.step + 1
    },
  },
  mounted() {
    this.fetchItem()
    if (!this.isNew) {
      const step1Session = getStepSession('confirmation', 1)
      this.readonly = step1Session.readonly
      this.fetchPreviousObject()
    }
  },
  methods: {
    async fetchPreviousObject() {
      // 差分抽出のため、前回承認前の値(previous_object)を取得する。
      const { data } = await window.axios.get(`/api/confirmations/${this.id}`)
      this.confirmationCreated = data.confirmation_created_at !== null
      this.confirmationApplied = data.confirmation_apply_status
      const { previous_object: object } = data
      if (!object || !object.id || !object.confirmation_created_at) {
        this.previousObject = {}
        return
      }
      // その他のテキストを復元
      object.structures
        .filter(item => !!item.pivot.other_text)
        .forEach(item => { data.previous_object.structures_other_text = item.pivot.other_text })
      object.features
        .filter(item => !!item.pivot.other_text)
        .forEach(item => { data.previous_object.features_other_text = item.pivot.other_text })

      this.previousObject = object
    },
    async fetchItem() {
      const { data } = await window.axios.get('/api/confirmations/props')
      this.structures = data.structures
      this.features = data.features
      this.roles = data.roles
      this.licenseTypes = data.license_types
    },
    goStep(step) {
      if (this.isNew) {
        this.$router.push({ name: `confirmationNewStep${step}` })
      } else {
        this.$router.push({ name: `confirmationEditStep${step}`, props: { id: this.id } })
      }
    },
  },
}
</script>
